<template>
  <div>
    <Map
      @selectedMarkers="selectedMarkers"
      @showCloseTooltip="showCloseTooltip"
      @group="group"
      ref="mapComponent"
    />

    <SelectedMarkersTable
      @refreshMap="refreshMap"
      @closeSelection="closeSelection"
      @showMarkerInfo="showMarkerInfo"
      :category="category"
      :markers="markers"
      :group="groupItem"
      ref="selectedMarkersTable"
    />

    <MapFilters
      @showHideGroupedAppointments="showHideGroupedAppointments"
      @filter="filter"
    />

    <MapPauseOffer v-if="isAdminOrPartner" />
  </div>
</template>

<script>
import Map from './mapDrawing/Map.vue'
import MapFilters from './mapDrawing/MapFilters.vue'
import MapPauseOffer from './mapDrawing/MapPauseOffer.vue';
import SelectedMarkersTable from './mapDrawing/SelectedMarkersTable'
import { checkUserRole } from '@/util/helpers'

export default {
  name: 'MapDrawing',

  components: {
    Map,
    MapFilters,
    SelectedMarkersTable,
    MapPauseOffer,
  },

  computed: {
    isAdminOrPartner() {
      return checkUserRole(['ROLE_ADMIN', 'ROLE_PARTNER'])
    },
  },

  methods: {
    group(group) {
      this.groupItem = group
    },

    selectedMarkers(markers) {
      this.markers = markers
    },

    refreshMap(filters) {
      this.$refs?.mapComponent?.fetchAppointmentsAndSetMarkers(filters, this.hideGroupedAppointments)
    },

    filter(filter) {
      this.filters = { ...this.filters, ...filter }
      this.category = filter.category
      this.refreshMap(this.filters)
    },

    closeSelection(hasGroupId) {
      this.markers = []
      this.groupItem = null
      this.$refs.mapComponent?.resetSelection()
      if (hasGroupId) this.refreshMap(this.filters)
    },

    showMarkerInfo(markerId) {
      this.$refs?.mapComponent?.showMarkerInfo(markerId)
    },

    showHideGroupedAppointments(value) {
      this.hideGroupedAppointments = value
      this.refreshMap(this.filters)
    },

    showCloseTooltip() {
      const selectedMarkersButtons = this.$refs.selectedMarkersTable?.$refs?.selectedMarkersButtons
      selectedMarkersButtons?.showCloseTooltip()
    },
  },

  data() {
    return {
      groupItem: null,
      markers: [],
      filters: null,
      hideGroupedAppointments: false,
      category: 'APPOINTMENTS',
    }
  }
}
</script>
